export default __webpack_public_path__ + "static/media/DNo.16-0.d2371120.jpg";